import { DOCUMENT } from '@angular/common';
import { Store } from '@ngrx/store';
import { Inject, Injectable } from '@angular/core';
import * as fromOptly from '../store/actions';
import * as fromOptlyQuery from '../store/selectors';
import * as fromOptlyState from '../store/reducers';

@Injectable({
  providedIn: 'root',
})
export class OptlyService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public readonly store?: Store<fromOptlyState.OptlyState>
  ) {}

  readonly experiments$ = this.store.select(fromOptlyQuery.getExperiments);

  readonly isExperimentActive$ = (props) =>
    this.store.select(fromOptlyQuery.isExperimentActive, { props });

  loadExperiments(payload: string[]) {
    this.store.dispatch(fromOptly.loadExperiments({ payload }));
  }

  addWrapperClasses() {
    setTimeout(() => {
      const activeExperiments = document.querySelectorAll('.optly');
      if (activeExperiments.length) {
        let arr = [];
        activeExperiments.forEach((item) => {
          const classes = item.classList.toString().split(' ');
          arr = [...arr, ...classes].filter((c) => c !== 'optly');
        });
        this.loadExperiments(arr);
      }
    });
  }
}
